import axios from "axios";

class TopLevelService {
  getUsers() {
    return axios.get(`${process.env.VUE_APP_TopLevelAPIPath}/api/Account/Users`);
  }
}

export default new TopLevelService();